import mutations from './mutations.js'
import actions from './actions.js'
import getters from './getters.js'


export default {
	state() {
		return {
			data: {},
			emptyDatabae: false,
			errorDatabase: false,
		}
	},
	mutations,
	actions,
	getters,
}
